import { render } from "./Icon.vue?vue&type=template&id=8c2fe6b2"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import "./Icon.vue?vue&type=style&index=0&id=8c2fe6b2&lang=css"
script.render = render

export default script